interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const UploadIcon = (props: PropsType) => {
  return (
    <svg
      width="30"
      height="27"
      viewBox="0 0 30 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.style ? props.style : undefined}
    >
      <path d="M3 15V25H27V15" stroke={props.color ? props.color : 'white'} strokeWidth="2" strokeLinecap="round" />
      <path
        d="M14.9997 1C15.2441 1 15.4777 1.10185 15.6468 1.28146L22.7545 8.85462C23.0004 9.11681 23.0683 9.50217 22.9277 9.83455C22.7871 10.1669 22.4646 10.3823 22.1074 10.3823H19.2418V19.0951C19.2418 19.5947 18.8418 20 18.3488 20H11.6505C11.1575 20 10.7582 19.5947 10.7582 19.0951V10.3823H7.89261C7.53542 10.3823 7.21287 10.1669 7.0723 9.83455C6.93173 9.50217 6.99964 9.11681 7.24546 8.85462L14.3532 1.28146C14.5216 1.10185 14.7552 1 14.9997 1Z"
        fill={props.color ? props.color : 'white'}
      />
    </svg>
  );
};

export default UploadIcon;
